import '@splidejs/splide/css/core';
import "./components/g-web-components";
// All
import "./components/g-hero"
import "./components/g-modal";
import "./components/hide-banner"
import "./components/recently-viewed-products";
import "./components/g-carousel";
import "./components/g-product-item";
import "./components/featured-picks-carousel";
import "./components/g-collapsible-text";
import "./components/favourite-product";
import "./components/footer";
import "./components/g-dropdown";
import "./components/g-header";
import "./components/scroll-header";
import "./components/header-menu";
import "./components/address-list";
import "./components/varify";
// Searchbar
import "./components/suggestion-list"
import "./components/header-searchbar";
// Home
import "./components/recommendation-carousel-by-order"
// Cart
import "./components/cart-delivery-progress-bar";
import "./components/cart-drawer-recommendations-item";
import "./components/cart-product-state-selector";
import "./components/cart-recommendations";



updateProductHref();

function updateProductHref() {
  const productHref = window.location.pathname
  let nextURL = window.location.origin

  if (document.body.classList.contains('js-product-not-found') && productHref.includes('products')) {
    const productId = productHref.split('/').pop().split('-')[0]
    const productNumber = +productHref.split('/').pop().split('-')[1] || 0

    if (productNumber >= 10) {
      return
    }

    nextURL = nextURL + `/products/${productId}-${productNumber + 1}`

    window.location.href = nextURL;
  }
}